import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

import t from '../../lib/I18n';

import FormattedHTMLMessage from './FormattedHTMLMessage';

function ExternalLink ({ message, href, className, messageClassName, noUnderline, srOnly, rel, ...rest }) {
    const anchorClassName = cn('external-link-no-underline', className);
    const msgClassName = cn('external-link', {
        'external-link-no-underline': noUnderline
    }, messageClassName);

    return (
        <a className={ anchorClassName } rel={ rel } href={ href } target="_blank" {...rest}>
            <FormattedHTMLMessage className={ msgClassName } message={ message } />
            <span className="external-link__spacer">&nbsp;</span>
            <i className='otrl otrl-externallink' />
            <span className="sr-only">{ srOnly }{ t('global.externalLink') }</span>
        </a>
    );
}

ExternalLink.propTypes = {
    message: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    className: PropTypes.string,
    messageClassName: PropTypes.string,
    noUnderline: PropTypes.bool,
    srOnly: PropTypes.string,
    rel: PropTypes.string,
};

ExternalLink.defaultProps = {
    className: '',
    messageClassName: '',
    noUnderline: false,
    srOnly: '',
    rel: null,
};

export default ExternalLink;



// WEBPACK FOOTER //
// ./src/components/general/ExternalLink.js